import { TextField } from "../runtime";
import type { DisplayObjectContainer, TextFormat } from "../runtime";

export const FONT_BODY = "PF Ronda Seven";
export const FONT_DISPLAY = "TRS Million";

export const TEXT_COLOURS = {
  white: 0xffffff,
  aqua: 0x00fff6,
  red: 0xff0000,
  yellow: 0xffea00,
  cyan: 0x00f0ff,
  lightCyan: 0x00fcff,
  mutedAqua: 0x5f8f8a,
} as const;

export interface TextFieldOptions {
  readonly width: number;
  readonly height: number;
  readonly centerX?: boolean;
  readonly x?: number;
  readonly y?: number;
  readonly text?: string;
  readonly wordWrap?: boolean;
  readonly embedFonts?: boolean;
  readonly selectable?: boolean;
}

/** creates and attaches one embedded game text field. */
export function createTextField(
  parent: DisplayObjectContainer,
  format: TextFormat,
  options: TextFieldOptions,
): TextField {
  const field = new TextField();
  field.defaultTextFormat = format;
  parent.addChild(field);
  field.embedFonts = options.embedFonts ?? true;
  field.selectable = options.selectable ?? false;
  field.wordWrap = options.wordWrap ?? true;
  field.width = options.width;
  field.height = options.height;
  if (options.centerX === true) {
    field.x = field.width * -0.5;
  } else if (options.x !== undefined) {
    field.x = options.x;
  }
  if (options.y !== undefined) {
    field.y = options.y;
  }
  if (options.text !== undefined) {
    field.text = options.text;
  }
  return field;
}
